import React, { useContext, useState } from "react";
import { Modal } from "@clarkinc/zest-design-system";
import { Tag } from "@clarkinc/zest-design-system/ui";
import { FilterModalContext } from "../FilterModalContextProvider";

interface FilterChipProps {
  filterName: string;
  filterValue: string;
  filterUrl: string;
  setIsFilterRemoved?: (isCleared: boolean) => void;
}

const FilterChip = ({
  filterName,
  filterValue,
  filterUrl,
  setIsFilterRemoved,
}: FilterChipProps) => {
  const [isSelected, setIsSelected] = useState(true);
  const filterType = filterName === "Show Parts" ? "Parts" : filterName;

  const { compareProductsActive, storedFilterUrl } =
    useContext(FilterModalContext);

  const shouldOpenModal = compareProductsActive && storedFilterUrl;

  const handleRemoveFilter = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();

    const isModelFilter = filterName === "Model";

    if (shouldOpenModal) {
      Modal.open("confirm-edit-filters-warning");
      storedFilterUrl.current.url = filterUrl;
      if (storedFilterUrl.current.confirmed) {
        setIsSelected(false);
        if (setIsFilterRemoved) {
          setIsFilterRemoved(isModelFilter);
        }
      }
    } else {
      setIsSelected(false);

      if (setIsFilterRemoved) {
        setIsFilterRemoved(isModelFilter);
      }

      if (isModelFilter) {
        // If it's a model filter, do not refresh
        window.history.replaceState(null, "", filterUrl);
      } else {
        // For non-model filters, refresh
        window.location.href = filterUrl;
      }
    }
  };

  return (
    <>
      {isSelected && (
        <Tag
          onClose={(e) => handleRemoveFilter(e)}
          size="small"
          theme="wss"
          type={filterType}
          value={filterValue}
        />
      )}
    </>
  );
};
export default FilterChip;
